
// 県全域の共通カラーコード
const prefColorCode = "#f8d042";
const prefColorClass = "h-hou-zeniki";
const prefTileLayerName = "90_hiroshima_pref";

const kashika4Options = [
  
    {
        menuName: "法規制マップ",
        activateAccordion: true,
        useAccordion: false,
        options: [

            {
                label: "都市計画法",
                type: "vector",
                id: "vis_90_1",
                layerName: "90_toshikeikaku",
                color:"#f7a34a",
                legendColorClass: "h-hou-toshi",
                url:process.env.REACT_APP_LAW_TILE_90_1,
            },

            {
                label: "県砂防指定地管理条例",
                type: "vector",
                id: "vis_90_2",
                layerName: "77_1_sabo",
                color:"#484572",
                legendColorClass: "h-hou-sabou",
                url:process.env.REACT_APP_LAW_TILE_90_2,
            },

            {
                label: "急傾斜地の崩壊による災害の防止に関する法律",
                type: "marker",
                id: "vis_90_3",
                menuIcon: true,
                column_lat: "緯度",
                column_lng: "経度",
                url:process.env.REACT_APP_LAW_MARKER_90_3,
            },

            {
                label: "地すべり等防止法",
                type: "vector",
                id: "vis_90_4",
                layerName: "77_3_jisuberi",
                color:"#fa5659",
                legendColorClass: "h-hou-jisuberi",
                url:process.env.REACT_APP_LAW_TILE_90_4,
            },

            {
                label: "森林法",
                id: "vis_90_5",
                color:"#4db659",
                legendColorClass: "h-hou-shinrin",
                hasChild: true,
                subLayers: [
                    {
                        label: "国有林",
                        type: "vector",
                        id: "vis_90_5_1",
                        layerName: "90_5_1_forest_kokuyu",
                        color:"#1E6739",
                        legendColorClass: "h-shinrinhou-kokuyuurin",
                        url:process.env.REACT_APP_LAW_TILE_90_5_1,
                    },

                    {
                        label: "国有保安林",
                        type: "vector",
                        id: "vis_90_5_2",
                        layerName: "90_5_2_forest_kokuyu_hoan",
                        color:"#BBBC20",
                        legendColorClass: "h-shinrinhou-kokuyuuhoanrin",
                        url:process.env.REACT_APP_LAW_TILE_90_5_2,
                    },

                    {
                        label: "地域森林計画対象民有林区域",
                        type: "vector",
                        id: "vis_90_5_3",
                        layerName: "90_5_3_forest_minyu",
                        color:"#B1EEB3",
                        legendColorClass: "h-shinrinhou-tiiki",
                        url:process.env.REACT_APP_LAW_TILE_90_5_3,
                    },

                    {
                        label: "民有保安林",
                        type: "vector",
                        id: "vis_90_5_4",
                        layerName: "90_5_4_forest_minyu_hoan",
                        color:"#51C878",
                        legendColorClass: "h-shinrinhou-minyuu",
                        url:process.env.REACT_APP_LAW_TILE_90_5_4,
                    },
                ]
            },
          
            {
                label: "自然公園法－県自然公園条例",
                type: "vector",
                id: "vis_90_6",
                layerName: "90_shizen_kouen",
                color:"#229470",
                legendColorClass: "h-hou-shizen",
                url:process.env.REACT_APP_LAW_TILE_90_6,
            },

            {
                label: "県自然環境保全条例－県自然海浜保全条例",
                type: "vector",
                id: "vis_90_7",
                color:prefColorCode,
                legendColorClass: prefColorClass,
                layerName: prefTileLayerName,
                url:process.env.REACT_APP_LAW_TILE_90_7,
            },

            {
                label: "道路法",
                type: "vector",
                id: "vis_90_8",
                color:prefColorCode,
                legendColorClass: prefColorClass,
                layerName: prefTileLayerName,
                url:process.env.REACT_APP_LAW_TILE_90_7,
            },

            {
                label: "河川法",
                id: "vis_90_9",
                legendColorClass: "h-kasenho",
                hasChild: true,
                subLayers: [
                    {
                        label: "河川法",
                        type: "vector",
                        id: "vis_90_9_1",
                        layerName: prefTileLayerName,
                        borderColor : "#996bd3",
                        legendColorClass: "h-kasenho",
                        url:process.env.REACT_APP_LAW_TILE_90_7,
                    },
                    {
                        label: "一級河川（指定区間）",
                        type: "vector",
                        id: "vis_90_9_2",
                        layerName: "90_9_2_river_center_line_1_in",
                        borderColor : "#1f4bba",
                        legendColorClass: "h-kasenho-1",
                        url:process.env.REACT_APP_LAW_TILE_90_9_2,
                    },

                    {
                        label: "二級河川",
                        type: "vector",
                        id: "vis_90_9_3",
                        layerName: "90_9_3_river_center_line_2",
                        borderColor : "#2399eb",
                        legendColorClass: "h-kasenho-2",
                        url:process.env.REACT_APP_LAW_TILE_90_9_3,
                    },

                ]
            },

            {
                label: "普通河川等保全条例",
                type: "vector",
                id: "vis_90_10",
                color:prefColorCode,
                legendColorClass: prefColorClass,
                layerName: prefTileLayerName,
                url:process.env.REACT_APP_LAW_TILE_90_7,
            },

            {
                label: "特定都市河川浸水被害対策法",
                type: "vector",
                id: "vis_100",
                layerName: "100_ryuiki",
                color : "#2399eb",
                legendColorClass: "h-jishin-lv3",
                url:process.env.REACT_APP_LAW_TILE_100,
            },
          
            {
                label: "文化財保護法",
                id: "vis_90_11",
                legendColorClass: prefColorClass,
                hasChild: true,
                subLayers: [
                    {
                        label: "文化財保護法",
                        type: "vector",
                        id: "vis_90_11_1",
                        layerName: prefTileLayerName,
                        borderColor : prefColorCode,
                        legendColorClass: prefColorClass,
                        url:process.env.REACT_APP_LAW_TILE_90_7,
                    },

                    {
                        label: "集落跡・散布地",
                        type: "marker",
                        id: "vis_90_11_4",
                        menuIcon: true,
                        url:process.env.REACT_APP_LAW_MARKER_90_11_4,
                        column_lat: "緯度",
                        column_lng: "経度",
                    },
                    {
                        label: "貝塚",
                        type: "marker",
                        id: "vis_90_11_3",
                        menuIcon: true,
                        url:process.env.REACT_APP_LAW_MARKER_90_11_3,
                        column_lat: "緯度",
                        column_lng: "経度",
                    },
                    {
                        label: "都城・官衙跡",
                        type: "marker",
                        id: "vis_90_11_5",
                        menuIcon: true,
                        url:process.env.REACT_APP_LAW_MARKER_90_11_5,
                        column_lat: "緯度",
                        column_lng: "経度",
                    },
                    {
                        label: "城館跡",
                        type: "marker",
                        id: "vis_90_11_6",
                        menuIcon: true,
                        url:process.env.REACT_APP_LAW_MARKER_90_11_6,
                        column_lat: "緯度",
                        column_lng: "経度",
                    },
                    {
                        label: "社寺跡",
                        type: "marker",
                        id: "vis_90_11_7",
                        menuIcon: true,
                        url:process.env.REACT_APP_LAW_MARKER_90_11_7,
                        column_lat: "緯度",
                        column_lng: "経度",
                    },
                    {
                        label: "生産遺跡",
                        type: "marker",
                        id: "vis_90_11_8",
                        menuIcon: true,
                        url:process.env.REACT_APP_LAW_MARKER_90_11_8,
                        column_lat: "緯度",
                        column_lng: "経度",
                    },
                    {
                        label: "古墳・横穴",
                        type: "marker",
                        id: "vis_90_11_2",
                        menuIcon: true,               
                        url:process.env.REACT_APP_LAW_MARKER_90_11_2,
                        column_lat: "緯度",
                        column_lng: "経度",
                    },
                    {
                        label: "その他の墳墓",
                        type: "marker",
                        id: "vis_90_11_9",
                        menuIcon: true,
                        url:process.env.REACT_APP_LAW_MARKER_90_11_9,
                        column_lat: "緯度",
                        column_lng: "経度",
                    },
                    {
                        label: "近代以降の単独遺跡",
                        type: "marker",
                        id: "vis_90_11_10",
                        menuIcon: true,
                        url:process.env.REACT_APP_LAW_MARKER_90_11_10,
                        column_lat: "緯度",
                        column_lng: "経度",
                    },
                    {
                        label: "その他",
                        type: "marker",
                        id: "vis_90_11_11",
                        menuIcon: true,
                        url:process.env.REACT_APP_LAW_MARKER_90_11_11,
                        column_lat: "緯度",
                        column_lng: "経度",
                    },
                    {
                        label: "水中遺跡",
                        type: "marker",
                        id: "vis_90_11_12",
                        menuIcon: true,
                        url:process.env.REACT_APP_LAW_MARKER_90_11_12,
                        column_lat: "緯度",
                        column_lng: "経度",
                    }
                ]
            },



            {
                label: "建設工事に係る資材の再資源化等に関する法律",
                type: "vector",
                id: "vis_90_12",
                color:prefColorCode,
                legendColorClass: prefColorClass,
                layerName: prefTileLayerName,
                url:process.env.REACT_APP_LAW_TILE_90_7,
            },

            {
                label: "広島県土砂の適正処理に関する条例",
                type: "vector",
                id: "vis_90_13",
                color:prefColorCode,
                legendColorClass: prefColorClass,
                layerName: prefTileLayerName,
                url:process.env.REACT_APP_LAW_TILE_90_7,
            },

            {
                label: "土壌汚染対策法",
                type: "vector",
                id: "vis_90_14",
                color:prefColorCode,
                legendColorClass: prefColorClass,
                layerName: prefTileLayerName,
                url:process.env.REACT_APP_LAW_TILE_90_7,
            },
          
            {
                label: "被爆樹木",
                type: "marker",
                id: "vis_90_15",
                menuIcon: true,
                url:process.env.REACT_APP_SPOT_90_15,
            },
        ]
    },
  
    {
        menuName: "宅地造成及び特定盛土等規制法",
        activateAccordion: true,
        useAccordion: true,
        options: [

            {
                label: "宅地造成等工事規制区域",
                type: "vector",
                id: "vis_90_16_1",
                layerName: "90_16_1_takuchi_zousei",
                color:"#ffd8f1",
                legendColorClass: "h-takuchizousei",
                showDatasetLink: true,
                url:process.env.REACT_APP_LAW_TILE_90_16_1,
            },

            {
                label: "特定盛土等規制区域",
                type: "vector",
                id: "vis_90_16_2",
                layerName: "90_16_2_tokutei_morido",
                color:"#afdc9a",
                legendColorClass: "h-tokuteimorido",
                showDatasetLink: true,
                url:process.env.REACT_APP_LAW_TILE_90_16_2,
            },

            {
                label: "許可盛土等（法第12条第1項・30条第1項）",
                type: "marker",
                id: "vis_90_16_3",
                menuIcon: true,
                column_lat: "座標（緯度）",
                column_lng: "座標（経度）",
                showDatasetLink: true,
                url:process.env.REACT_APP_LAW_MARKER_90_16_3,
            },

            {
                label: "届出盛土等（法第21条第1項・40条第1項）",
                type: "marker",
                id: "vis_90_16_4",
                menuIcon: true,
                column_lat: "座標（緯度）",
                column_lng: "座標（経度）",
                url:process.env.REACT_APP_LAW_MARKER_90_16_4,
                showDatasetLink: true,
                popupTitle: "届出盛土等（法第21条第1項・40条第1項）"
            },

            {
                label: "既存盛土等（法第4条第1項）",
                type: "marker",
                id: "vis_90_16_5",
                menuIcon: true,
                column_lat: "座標（緯度）",
                column_lng: "座標（経度）",
                url:"",
                popupTitle: "既存盛土等（法第4条第1項）",
                showDatasetLink: false,
                checkboxDisabled: false, // チェックボックスを表示しない
            },
        ]
    },


    {
        menuName: "ため池情報",
        activateAccordion: false,
        useAccordion: true,
        options: [
            {
                label: "ため池ポイント",
                type: "marker",
                dataset_id: 20,
                id: "tameike",
                column_lat: "緯度",
                column_lng: "経度",
                url:process.env.REACT_APP_TAMEIKE
            }
        ]
    }

];


export  {
    kashika4Options
};
